import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
import { ReactComponent as NoDataFound } from "../../assets/images/NoDataFound.svg";
import { ReactComponent as iIcon } from "../../assets/images/iIcon.svg";
import { ReactComponent as DangerCircle } from "../../assets/images/DangerCircle.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrganisation,
  getOrganisationMaster,
} from "../../reduxSlices/organisationSlice";
import {
  BASE_URL,
  CLIENT_ADMIN_ROLE_ID,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
  vfUserHeader,
} from "../../constants/constant";
import { IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Loader from "../../components/loader/Loader";
import styles from "./UserPage.module.css";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import SearchBar from "../../components/searchBar/SearchBar";
import CommonDropdown from "../../components/dropdown/CommonDropdown";
import TopBar from "../../components/topbar/TopBar";
import { getAllUsers, getUserLogin } from "../../reduxSlices/userSlice";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { toast } from "react-toastify";
import { Service } from "../../services/service";
import CommonDialog from "../../components/dialog/CommonDialog";
import NoResultFound from "../../components/noResultFound/NoResultFound";

const service = new Service();

export default function UserPage() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setName] = useState("");
  const allUsers = useSelector((state) => state.user.allUsers);
  const loading = useSelector((state) => state.user.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  // const typeValue = headerData.typeValue;
  // const packageValue = headerData.packageValue;
  const organisationValue = headerData.organisationValue;
  const accessValue = headerData.accessValue;
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const userEmailId = userData?.emailId;
  const organisationId = userData?.organisationId;
  const organisationName = userData?.organisationName;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  // const allUsers = usersData.filter((user) => user.emailId !== userEmailId);
  const searchParams = localStorage.getItem("searchParams");
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);
  const columns = isVfAdmin
    ? vfUserHeader
    : vfUserHeader.filter((obj) => obj.id !== "organisation");

  const organisationMaster = useSelector(
    (state) => state.organization.organisationMaster
  );
  const organisationOptions = organisationMaster?.map(
    (item, i) => item.organizationName
  );

  const getUserData = async () => {
    const obj = {
      searchText: searchInput || "",
      organizations: organisationValue,
      // organizations: isVfAdmin ? organisationValue : [organisationName],
      access: accessValue || [],
      organisationId: !isVfAdmin ? organisationId : "",
    };
    await dispatch(getAllUsers(obj));
  };

  const fetchUserLogin = async () => {
    const obj = {
      email: userEmailId,
    };
    await dispatch(getUserLogin(obj));
  };

  const handleMoreIcon = (event, data) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setId(data?.userId);
    setName(data);
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "users",
        title: "Users",
        subTitle: !isVfAdmin
          ? "Here is the list of all users in your organisation along with their details"
          : "Here is the list of all users across different organisations along with their details",
      })
    );
    dispatch(getOrganisationMaster());
  }, []);

  useEffect(() => {
    getUserData();
  }, [dispatch]);

  const getOrganisationDataWithDebounce = debounce(() => {
    getUserData();
  }, 500);

  const organisationValueDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [organisationValue]
  );

  const accessValueDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [accessValue]
  );

  const searchInputDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  useEffect(() => {
    organisationValueDebounceLoadData();

    return organisationValueDebounceLoadData.cancel;
  }, [organisationValue, organisationValueDebounceLoadData]);

  useEffect(() => {
    accessValueDebounceLoadData();

    return accessValueDebounceLoadData.cancel;
  }, [accessValue, accessValueDebounceLoadData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (id) {
      console.log("id>>>>>>>", id);
      deleteUser(id);
      setOpen(false);
    }
  };

  const deleteUser = async (id) => {
    let url = `/api/User/DeleteUser?id=${id}&isDelete=${open}&isVFAdmin=false`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success(
          !open
            ? `User marked as ${data?.isActive ? "Inactive" : "Active"}`
            : `User has been deleted`,
          {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          }
        );
        getUserData();
        fetchUserLogin();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar
          isVfAdmin={isVfAdmin}
          searchParams={searchParams}
          organisationFilter={organisationOptions}
          accessFilter={accessOptions}
          placeholder="Search users here..."
        />
        {loading && allUsers.length === 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{ maxHeight: "calc(100vh - 320px)", padding: "0 0" }}
            className="table_container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#fff",
                        color: "#8a8a8a",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allUsers.length > 0 ? (
                  <>
                    {allUsers?.map((elem) => (
                      <TableRow hover key={elem.organizationId}>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#282828",
                            fontWeight: 600,
                          }}
                        >
                          {elem?.givenName || ""} {elem?.familyName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.emailId || ""}
                        </TableCell>
                        {isVfAdmin && (
                          <TableCell
                            style={{
                              borderColor: "#f2f4f9",
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            {elem?.organization?.organizationName || ""}
                          </TableCell>
                        )}
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.roles[0]?.roleId === USER_ROLE_ID
                            ? "Standard"
                            : "Admin"}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.isActive ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          align="center"
                        >
                          <MoreIcon onClick={(e) => handleMoreIcon(e, elem)} />
                        </TableCell>
                      </TableRow>
                    ))}
                    <ActionDropdown
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      editNavigate={`/edit-user/${id}`}
                      setOpen={setOpen}
                      isDelete={true}
                      isActive={true}
                      text={`Mark as ${data?.isActive ? "Inactive" : "Active"}`}
                      markAsActiveInactive={handleDelete}
                    />
                  </>
                ) : (
                  <NoResultFound
                    description="We couldn’t find any matches for search query or applied filter. Please try different
                  keyword or filters."
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle={`Are you sure you want to delete <span style="font-weight: 700;">${`${
          data?.givenName || ""
        } ${
          data?.familyName || ""
        }`}</span> as an user? You’ll not be able to reverse this action.`}
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
    </>
  );
}

const accessOptions = ["Standard", "Admin"];
